import { render, staticRenderFns } from "./Schooldetail.vue?vue&type=template&id=b9783c8e&scoped=true&"
import script from "./Schooldetail.vue?vue&type=script&lang=js&"
export * from "./Schooldetail.vue?vue&type=script&lang=js&"
import style0 from "./Schooldetail.vue?vue&type=style&index=0&id=b9783c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9783c8e",
  null
  
)

export default component.exports